import React from 'react';
import {motion} from 'framer-motion';
import {BarChart,Bar,XAxis,YAxis,CartesianGrid,Tooltip,ResponsiveContainer} from 'recharts';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiBriefcase,FiTrendingUp}=FiIcons;

const PracticeAreas=()=> {
  const practiceData=[ 
    {name: 'Life Insurance',attendees: 1082,percentage: 32.6},
    {name: 'General Insurance',attendees: 547,percentage: 16.5},
    {name: 'Health & Care',attendees: 320,percentage: 9.6},
    {name: 'Consulting',attendees: 208,percentage: 6.3},
    {name: 'Pensions',attendees: 181,percentage: 5.4},
    {name: 'Data Science',attendees: 173,percentage: 5.2},
    {name: 'Students',attendees: 500,percentage: 15.1},
    {name: 'Other',attendees: 310,percentage: 9.3} 
  ];

  const CustomTooltip=({active,payload,label})=> {
    if (active && payload && payload.length) {
      const data=payload[0].payload;
      return ( 
        <div className="glass-effect rounded-lg p-3 border border-white/20">
          <p className="text-white font-semibold">{label}</p>
          <p className="text-blue-200">{data.attendees} attendees ({data.percentage}%)</p>
        </div> 
      );
    } 
    return null;
  };

  return ( 
    <motion.div 
      className="glass-effect rounded-2xl p-8" 
      initial={{opacity: 0,y: 20}} 
      animate={{opacity: 1,y: 0}} 
      transition={{duration: 0.6}} 
    >
      <div className="text-center mb-8">
        <motion.h2 
          className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center" 
          initial={{opacity: 0}} 
          animate={{opacity: 1}} 
          transition={{delay: 0.2}} 
        >
          <SafeIcon icon={FiBriefcase} className="text-green-400 mr-3" />
          Practice Area Distribution 
        </motion.h2>
        <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-blue-500 mx-auto rounded-full" /> 
      </div>

      <motion.div 
        className="h-96 mb-8" 
        initial={{opacity: 0,scale: 0.9}} 
        animate={{opacity: 1,scale: 1}} 
        transition={{delay: 0.3}} 
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart 
            data={practiceData} 
            margin={{top: 20,right: 30,left: 20,bottom: 60}} 
          >
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" /> 
            <XAxis 
              dataKey="name" 
              tick={{fill: 'white',fontSize: 12}} 
              angle={-45} 
              textAnchor="end" 
              height={80} 
            />
            <YAxis tick={{fill: 'white',fontSize: 12}} /> 
            <Tooltip content={<CustomTooltip />} /> 
            <Bar 
              dataKey="attendees" 
              fill="url(#practiceGradient)" 
              radius={[4,4,0,0]} 
            />
            <defs> 
              <linearGradient id="practiceGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#10B981" /> 
                <stop offset="100%" stopColor="#3B82F6" /> 
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </motion.div>

      <motion.div 
        className="bg-gradient-to-r from-green-500/20 to-blue-500/20 rounded-xl p-6 border border-green-500/30" 
        initial={{opacity: 0,scale: 0.95}} 
        animate={{opacity: 1,scale: 1}} 
        transition={{delay: 0.6}} 
      >
        <h3 className="text-xl font-bold text-white mb-3 flex items-center">
          <SafeIcon icon={FiTrendingUp} className="text-green-400 mr-2" />
          Strategic Sector Alignment 
        </h3>
        <p className="text-white/90 leading-relaxed">
          <span className="font-bold text-green-300">49% from Life & General Insurance</span> - the core sectors driving AI adoption. Additional representation from consulting,health care,and data science creates comprehensive market coverage across all key actuarial sectors. 
        </p>
      </motion.div>
    </motion.div> 
  );
};

export default PracticeAreas;